module.exports = __webpack_public_path__ + "media/images/logo-og-4c0fcec07e3661f98b2b9313ba52f6f2.png";